import { Link } from "react-router-dom";
import { Href, MoreComments } from "../../../../../../constants";
import { SocialChatData } from "../../../../../../data/applications/SocialApp";
import { dynamicImage } from "../../../../../../utils";
import { Image } from "../../../../../../coreComponents/Image";

const SocialChat = () => {
  return (
    <div className="social-chat">
      {SocialChatData.map((data, index) => (
        <div className={data.class} key={index}>
          <div className="d-flex">
            <Image className="img-50 img-fluid m-r-20 rounded-circle" alt="user" src={dynamicImage(`user/${data.image}`)} />
            <div className="flex-grow-1">
              <span>
                {data.title}&nbsp;
                <span>
                  {data.year} <i className="fa fa-reply font-primary" />
                </span>
              </span>
              <p>{data.text}</p>
            </div>
          </div>
        </div>
      ))}
      <div className="text-center">
        <Link to={Href}>{MoreComments}</Link>
      </div>
    </div>
  );
};

export default SocialChat;
